import React from 'react'

const CarDeliveryPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Car Delivery Page</h1>
      <p>This is a placeholder for the Car Delivery page.</p>
    </div>
  )
}

export default CarDeliveryPage